import * as React from 'react';
import appConfig from '../../../../config/main';
import Helmet from 'react-helmet';
import Header from './scenes/Header';
import Footer from './scenes/Footer';
import { IChannel } from '../../data/api/models';

interface IShellProps {
  steps: object;
  channel: IChannel;
}

class Shell extends React.Component<IShellProps> {
  public render() {
    const { children, steps, channel } = this.props;

    const brandTemplate =  {
      titleTemplate: `${channel.baseName}: %s`,
    };

    return (
      <div>
        <Helmet {...appConfig.app.head} {...brandTemplate} />
        <Header steps={steps} channel={channel} />
        {children}
        <Footer channel={channel} />
      </div>
    );
  }
}

export default Shell;
